import {FORM_ORDER_CASH_REPLENISHMENT} from 'shared/constants/ActionTypes';

const initalState = {
  formOrder: {},
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case FORM_ORDER_CASH_REPLENISHMENT:
      return {
        ...state,
        formOrder: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
